'use strict'
module.exports ='qf-web'


//////////////////
// WEBPACK FOOTER
// ./config/basePath.js
// module id = cA2Q
// module chunks = 1